import React from "react";
import Select from "./Select.jsx";

const customStyles = {
  container: (provided, state) => ({
    ...provided,
    width: "100%",
    boxShadow: "none",
    background: "transparent",
    border: "none",
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    paddingRight: 0,
    paddingLeft: 0,
  }),
  indicatorContainer: (provided, state) => ({
    ...provided,
    paddingRight: 0,
    paddingLeft: 0,
  }),
  control: (provided, state) => ({
    ...provided,
    minHeight: 34,
  }),
  indicatorSeparator: (provided, state) => ({
    display: "none",
  }),
  menu: (provided, state) => ({
    ...provided,
    zIndex: 99999,
    width: "calc(100% + 30px)", // Full width of cell (30px for the undo arrow)
  }),
};

const GridSelect = (props) => {
  return <Select {...props} styles={customStyles} />;
};

export default GridSelect;
